<script>
  import RichText from "$lib/components/RichText.svelte";

  export let data;
  export let componentMap;
</script>

<RichText node={data.fields.richTextContent} {componentMap} />
